var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-toggle-button-wrapper"},[_c('button',{attrs:{"id":"navigation-toggle-button","title":"Меню"},on:{"click":function($event){return _vm.$emit('toggle-main-navigation')}}},[_c('span',{class:['hamburger-icon', { active: _vm.isActive }]})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d639a98c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/the-header/navigation-main/NavigationMainToggleButton.vue
// module id = null
// module chunks = 